import { render, staticRenderFns } from "./index-yye-pie.vue?vue&type=template&id=23939b9b&scoped=true&"
import script from "./index-yye-pie.vue?vue&type=script&lang=js&"
export * from "./index-yye-pie.vue?vue&type=script&lang=js&"
import style0 from "./index-yye-pie.vue?vue&type=style&index=0&id=23939b9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23939b9b",
  null
  
)

export default component.exports